/**
 * US phone formatting + validation shared by Register and Settings.
 *
 * Twilio A2P 10DLC compliance: phone is optional, sms_opt_in must not be
 * granted without a 10-digit phone. Formatter caps at 10 digits and strips
 * a leading "1" country code so pasted "+15551234567" becomes "5551234567".
 */

export function formatPhone(value: string): string {
    let digits = value.replace(/\D/g, '');

    if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.slice(1);
    }

    digits = digits.slice(0, 10);

    if (digits.length === 0) return '';
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function isPhoneValid(value: string): boolean {
    return value.replace(/\D/g, '').length === 10;
}

export function phoneDigits(value: string): string {
    return value.replace(/\D/g, '');
}
